// PDLProfileModal.jsx (ES5-style, no optional chaining)
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal, ButtonToolbar } from 'reactstrap';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';

// Icons
import ProfileIcon from 'mdi-react/AccountBoxOutlineIcon';
import ActiveIcon from 'mdi-react/CheckCircleOutlineIcon';
import EmailOutlineIcon from 'mdi-react/EmailOutlineIcon';
import PhoneIcon from 'mdi-react/PhoneIcon';
import MapMarkerIcon from 'mdi-react/MapMarkerOutlineIcon';
import ChevronRightIcon from 'mdi-react/ChevronRightIcon';

import LinearLoading from './../LinearLoading';
import { _axiosCall } from '../../helpers/apicalls';
import { _hasPermission } from '../../helpers/access';

import { 
  _capitalizeText,
  _formatNumber,
  _formatPrice
} from "../../helpers/utils";
var apiRoot = process.env.API_ROOT;


class PDLProfileModal extends PureComponent {
  constructor(props) {
	super(props);
	this.state = {
	  modal: false,
	  loading: false,
	  error: null,
	  pdl_result: null,
	  expanded: true
	};

	this.toggle = this.toggle.bind(this);
	this._loadPDL = this._loadPDL.bind(this);
	this._renderPDLSection = this._renderPDLSection.bind(this);
	this._ListItem = this._ListItem.bind(this);
	this._formatPhoneDisplay = this._formatPhoneDisplay.bind(this);
	this._toggleExpanded = this._toggleExpanded.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
	var controlled = typeof this.props.isOpen === 'boolean';
  
	if (controlled) {
	  // Controlled: watch props.isOpen
	  if (!prevProps.isOpen && this.props.isOpen) {
		this._loadPDL();
	  }
	} else {
	  // Uncontrolled: watch internal state.modal
	  if (!prevState.modal && this.state.modal) {
		this._loadPDL();
	  }
	}
  }


  toggle(e) {
	if (e && e.preventDefault) { e.preventDefault(); e.stopPropagation(); }
	var isControlled = typeof this.props.isOpen === 'boolean';
  
	if (isControlled) {
	  if (this.props.isOpen && typeof this.props.onClose === 'function') {
		this.props.onClose();
	  }
	  return;
	}
  
	var next = !this.state.modal;
	this.setState({ modal: next });
  }


  _toggleExpanded(e) {
	if (e && e.preventDefault) {
	  e.preventDefault();
	  e.stopPropagation();
	}
	this.setState({ expanded: !this.state.expanded });
  }

  _formatPhoneDisplay(num) {
	var s = (num || '').replace(/[^\d]/g, '');
	if (s.length === 11 && s.indexOf('1') === 0) s = s.substring(1);
	if (s.length === 10) return '(' + s.substring(0,3) + ') ' + s.substring(3,6) + '-' + s.substring(6);
	return num || '-';
  }

  _mailto(email) {
	var e = (email || '').trim();
	return 'mailto:' + encodeURIComponent(e);
  }

  _tel(num) {
	var s = (num || '').trim();
	var cleaned = s.replace(/(?!^\+)[^\d]/g, '');
	return 'tel:' + cleaned;
  }

  _ListItem(props) {
	var icon = props.icon;
	var href = props.href;
	var target = props.target || (href && href.indexOf('http') === 0 ? '_blank' : null);
	var rel = target === '_blank' ? 'noopener noreferrer' : null;
	var meta = props.meta;
	var noBullet = props.noBullet;

	return (
	  <li style={{ listStyle: 'none', margin: '6px 0' }}>
		<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
		  {!noBullet ? <ChevronRightIcon size={16} color="#9aa4b2" /> : null}
		  {icon}
		  {href
			? <a
				href={href}
				target={target}
				rel={rel}
				className="link-text"
				style={{ textDecoration: 'none' }}
			  >
				{props.children}
			  </a>
			: <span>{props.children}</span>}
		  {meta}
		</div>
	  </li>
	);
  }

  _loadPDL() {
	if (this.state.loading) return;
	if (this.props.pdlPayload) {
	  this.setState({
		pdl_result: this.props.pdlPayload,
		loading: false,
		error: null
	  });
	  return;
	}

	var body = {
	  first_name: this.props.first_name || '',
	  last_name: this.props.last_name || '',
	  address_1: this.props.address_1 || '',
	  address_2: this.props.address_2 || '',
	  city: this.props.city || '',
	  state: this.props.state || '',
	  zip: this.props.zip || '',
	  email: this.props.email || '',
	  phone: this.props.phone || '',
	  location: this.props.location || '',
	  company: this.props.company || '',
	  linkedin_url: this.props.linkedin_url || ''
	};

	var userData = {
	  url: (this.props.url && this.props.url.trim().length > 0)
		? this.props.url
		: apiRoot + '/skip/skip-trace-pdl?cache=false',
	  method: 'post',
	  query: body
	};

	var self = this;
	this.setState({
	  loading: true,
	  error: null,
	  pdl_result: null,
	  expanded: false
	});

	_axiosCall(userData)
	  .then(function (res) {
		var data = res;
console.log(data)
		if (data && data.data && typeof data.likelihood !== 'undefined') {
		  self.setState({
			pdl_result: data,
			loading: false,
			error: null
		  });
		} else {
		  self.setState({
			loading: false,
			error: 'No People Data Labs match found.',
			pdl_result: null
		  });
		}
	  })
	  .catch(function (error) {
		var msg = error && error.message ? error.message : 'Request failed';
		if (error && error.data) {
		  try { msg = JSON.stringify(error.data); } catch (e) {}
		}
		self.setState({
		  loading: false,
		  error: msg,
		  pdl_result: null
		});
	  });
  }
  
  // ===============================
	// Flow detection
	// ===============================
	_isCompanyName(triggerDisplay) {
	  if (!triggerDisplay || typeof triggerDisplay !== 'string') return false;
	  function escapeRegExp(s) {
		return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	  }
	  var name = triggerDisplay.trim();
	  var lower = name.toLowerCase();
  
	  var companyKeywords = [
		'llc','llp','pllc','pc','plc',
		'inc','inc.','corp','corporation','company','co.',
		'ltd','limited',
		'gmbh','s.a.','sa','bv','nv','pty','srl','spa','ag','kg','k.k.','kk','oy','aps','as','ab','sas','sasu','sarl','lp','gp',
		'holdings','group','partners','associates','management','properties','realty','ventures','trust','foundation'
	  ];
  
	  for (var i = 0; i < companyKeywords.length; i++) {
		var kw = companyKeywords[i];
		var re = new RegExp('\\b' + escapeRegExp(kw) + '\\b', 'i');
		if (re.test(lower)) return true;
	  }
	  if (/(,|\().*\b(llc|inc\.?|ltd|corp|co\.|company|corporation)\b/i.test(lower)) return true;
	  return false;
	}

  _renderPDLSection(pdl) {
	if (!pdl) return null;
  
	var d = pdl && pdl.data ? pdl.data : {};
  
	var fullNameRaw = d.full_name || '';
	var firstNameRaw = d.first_name || '';
	var lastNameRaw  = d.last_name || '';
	var jobTitleRaw  = d.job_title || '';
	var companyRaw   = d.job_company_name || '';
	var companyLocRaw = d.job_company_location_name || '';
	var industryRaw  = d.industry || d.job_company_industry || '';
  
	var likelihood = (typeof pdl.likelihood !== 'undefined' && pdl.likelihood !== null)
	  ? String(pdl.likelihood)
	  : '';
	var datasetVersion = d.dataset_version || pdl.dataset_version || '';
  
	var countryRaw = d.location_country || '';
	var regionRaw = d.location_region || '';
  
	// Capitalize helpers
	function cap(val) {
	  if (!val) return '';
	  return _capitalizeText(val);
	}
  
	var fullName =
	  fullNameRaw ||
	  (cap(firstNameRaw) + (lastNameRaw ? ' ' + cap(lastNameRaw) : '')).trim();
  
	var jobTitle = cap(jobTitleRaw);
	var company  = cap(companyRaw);
	var industry = cap(industryRaw);
	var region   = cap(regionRaw);
	var country  = cap(countryRaw);
	var companyLoc = cap(companyLocRaw);
  
	var locationStr = '';
	if (region && country) {
	  locationStr = region + ', ' + country;
	} else if (country) {
	  locationStr = country;
	} else if (region) {
	  locationStr = region;
	}
  
	var linkedin = d.linkedin_url || '';
	var twitter  = d.twitter_url || '';
	var facebook = d.facebook_url || '';
  
	var profiles = d.profiles || [];
	var exp = d.experience || [];
	var edu = d.education || [];
	var skills = d.skills || [];
  
	// Build a combined list of all profiles (array + top-level ones).
	var allProfiles = [];
	var i;
  
	for (i = 0; i < profiles.length; i++) {
	  var p = profiles[i] || {};
	  allProfiles.push({
		network: p.network || '',
		url: p.url || '',
		username: p.username || ''
	  });
	}
  
	function hasUrl(list, url) {
	  if (!url) return false;
	  for (var j = 0; j < list.length; j++) {
		if (list[j].url === url) return true;
	  }
	  return false;
	}
  
	if (linkedin && !hasUrl(allProfiles, linkedin)) {
	  allProfiles.push({
		network: 'linkedin',
		url: linkedin,
		username: ''
	  });
	}
	if (facebook && !hasUrl(allProfiles, facebook)) {
	  allProfiles.push({
		network: 'facebook',
		url: facebook,
		username: ''
	  });
	}
	if (twitter && !hasUrl(allProfiles, twitter)) {
	  allProfiles.push({
		network: 'twitter',
		url: twitter,
		username: ''
	  });
	}
  
	var isExpanded = this.state.expanded;
  
	return (
	  <div style={{ border:'1px solid #ddd', borderRadius:10, padding:16 }}>
		<div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
		  <h5 style={{ textTransform:'uppercase', fontWeight:800, margin:0 }}>
			People Data Labs Profile
		  </h5>
		  <div style={{ fontSize:12, color:'#666', textAlign:'right' }}>
			{likelihood ? ('Match Likelihood: ' + likelihood + '/10') : null}
			{likelihood && datasetVersion ? ' • ' : null}
			{datasetVersion ? ('Dataset v' + datasetVersion) : null}
		  </div>
		</div>
  
		{/* Summary header */}
		<div style={{ background:'#F5F7FA', borderRadius:8, padding:16, marginBottom:10 }}>
		  <div style={{ display:'grid', gridTemplateColumns:'1.4fr 1.2fr 1.4fr 1fr', gap:10 }}>
			<div>
			  <strong>Full Name</strong><br/>
			  <span>{fullName || '-'}</span>
			</div>
			<div>
			  <strong>Title</strong><br/>
			  <span>{jobTitle || '-'}</span>
			</div>
			<div>
			  <strong>Company</strong><br/>
			  <span>{company || '-'}</span>
			</div>
			<div>
			  <strong>Industry</strong><br/>
			  <span>{industry || '-'}</span>
			</div>
		  </div>
  
		  <div style={{ display:'grid', gridTemplateColumns:'1.3fr 1.3fr 1.3fr', gap:10, marginTop:12 }}>
			<div>
			  <strong>Company Location</strong><br/>
			  <span>{companyLoc || '-'}</span>
			</div>
			<div>
			  <strong>Home Region</strong><br/>
			  <span>{locationStr || '-'}</span>
			</div>
			<div>
			  <strong>Primary LinkedIn</strong><br/>
			  {linkedin ? (
				<a
				  href={linkedin.indexOf('http') === 0 ? linkedin : ('https://' + linkedin)}
				  target="_blank"
				  rel="noopener noreferrer"
				  className="link-text"
				>
				  {linkedin}
				</a>
			  ) : <span>-</span>}
			</div>
		  </div>
		</div>
  
		<a
		  href="javascript:void(0)"
		  className="link-text"
		  onClick={this._toggleExpanded}
		>
		  {isExpanded ? 'Hide People Data Labs details' : 'Show People Data Labs details'}
		</a>
  
		{isExpanded ? (
		  <div style={{ marginTop:14 }}>
			{/* Profiles: all sources combined */}
			<div style={{ marginBottom:14 }}>
			  <p style={{ fontWeight:600, margin:'0 0 6px' }}>Profiles</p>
			  {allProfiles && allProfiles.length > 0 ? (
				<ul style={{ paddingLeft:0, margin:0 }}>
				  {allProfiles.map(function(p, idx){
					var net = p && p.network ? cap(p.network) : '';
					var url = p && p.url ? p.url : '';
					var username = p && p.username ? p.username : '';
					var href = url ? (url.indexOf('http') === 0 ? url : ('https://' + url)) : null;
					var label = url || username || '-';
					return (
					  <this._ListItem
						key={'pdl_prof_' + idx}
						icon={null}
						href={href}
						target="_blank"
					  >
						{net ? (net + ': ') : ''}{label}
					  </this._ListItem>
					);
				  }.bind(this))}
				</ul>
			  ) : <p>-</p>}
			</div>
  
			{/* Experience */}
			{exp && exp.length > 0 ? (
			  <div style={{ marginBottom:14 }}>
				<p style={{ fontWeight:600, margin:'0 0 6px' }}>Experience</p>
				{exp.slice(0, 6).map(function(e, i){
				  var co = e && e.company ? e.company : {};
				  var coName = cap(co.name || '');
				  var coLoc = co.location && co.location.name ? cap(co.location.name) : '';
				  var titleObj = e && e.title ? e.title : {};
				  var titleName = cap(titleObj.name || '');
				  var levels = titleObj.levels || [];
				  var roleRaw = titleObj.role || '';
				  var start = e && e.start_date ? e.start_date : '';
				  var end = e && e.end_date ? e.end_date : '';
				  var range = (start || end) ? ((start || '') + (end ? (' - ' + end) : '')) : '';
  
				  var role = roleRaw ? cap(roleRaw) : '';
				  var roleBits = [];
				  if (role) roleBits.push(role);
				  if (levels && levels.length > 0) roleBits.push(levels.join(', '));
				  var roleText = roleBits.length ? roleBits.join(' • ') : '';
  
				  return (
					<div
					  key={'pdl_exp_' + i}
					  style={{ border:'1px solid #eee', borderRadius:8, padding:10, marginBottom:8 }}
					>
					  <div style={{ fontWeight:600 }}>{coName || '-'}</div>
					  <div style={{ fontSize:13 }}>
						{titleName || '-'}
						{roleText ? (' • ' + roleText) : ''}
					  </div>
					  <div className="small-text light-text" style={{ marginTop:4 }}>
						{coLoc || '-'}
					  </div>
					  {range ? (
						<div className="small-text light-text" style={{ marginTop:2 }}>
						  {range}
						</div>
					  ) : null}
					</div>
				  );
				})}
			  </div>
			) : null}
  
			{/* Education */}
			{edu && edu.length > 0 ? (
			  <div style={{ marginBottom:14 }}>
				<p style={{ fontWeight:600, margin:'0 0 6px' }}>Education</p>
				{edu.map(function(ed, i){
				  var school = ed && ed.school ? ed.school : {};
				  var name = cap(school.name || '');
				  var degrees = ed && ed.degrees && ed.degrees.length
					? cap(ed.degrees.join(', '))
					: '';
				  var majors = ed && ed.majors && ed.majors.length
					? cap(ed.majors.join(', '))
					: '';
				  var start = ed && ed.start_date ? ed.start_date : '';
				  var end   = ed && ed.end_date ? ed.end_date : '';
				  var range = (start || end) ? ((start || '') + (end ? (' - ' + end) : '')) : '';
  
				  return (
					<div
					  key={'pdl_edu_' + i}
					  style={{ border:'1px solid #eee', borderRadius:8, padding:10, marginBottom:8 }}
					>
					  <div style={{ fontWeight:600 }}>{name || '-'}</div>
					  <div style={{ fontSize:13 }}>
						{degrees || majors ? (degrees + (degrees && majors ? ' • ' : '') + majors) : '-'}
					  </div>
					  {range ? (
						<div className="small-text light-text" style={{ marginTop:2 }}>
						  {range}
						</div>
					  ) : null}
					</div>
				  );
				})}
			  </div>
			) : null}
  
			{/* Skills */}
			{skills && skills.length > 0 ? (
			  <div>
				<p style={{ fontWeight:600, margin:'0 0 6px' }}>Skills</p>
				<div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
				  {skills.slice(0, 20).map(function(s, i){
					var skillLabel = cap(s);
					return (
					  <span
						key={'pdl_skill_' + i}
						style={{
						  fontSize:12,
						  padding:'3px 8px',
						  borderRadius:12,
						  border:'1px solid #ddd',
						  background:'#fafafa'
						}}
					  >
						{skillLabel}
					  </span>
					);
				  })}
				</div>
			  </div>
			) : null}
		  </div>
		) : null}
	  </div>
	);
  }


  render() {
	var user = this.props.user;
	var triggerDisplay = this.props.triggerDisplay;
	var isControlled = typeof this.props.isOpen === 'boolean';
	var isOpen = isControlled ? this.props.isOpen : this.state.modal;
	
	var isCompany = this._isCompanyName(triggerDisplay);
	if(isCompany){
		return null;
	}

	if (!_hasPermission(user, 'skip-trace')) {
	  return (
		<div style={{ fontSize: 13, whiteSpace: 'nowrap' }}>
		  {triggerDisplay}
		</div>
	  );
	}

	return (
	  <Fragment>
		{/* Trigger */}
		<div
		  className="link-text"
		  style={{ whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}
		  onClick={this.toggle}
		>
		  {triggerDisplay}
		  <Tooltip title="PDL Profile">
			<IconButton size="small">
			  <ProfileIcon size={16} color="#780F9E" />
			</IconButton>
		  </Tooltip>
		</div>

		<Modal
		  isOpen={isOpen}
		  modalClassName="ltr-support"
		  className="modal-dialog--primary modal-dialog--header"
		  toggle={this.toggle}
		  style={{ minWidth: '65%' }}
		  scrollable={true}
		>
		  <div className="modal__header">
			<button className="lnr lnr-cross modal__close-btn" onClick={this.toggle} />
			<h4 className="modal__title">
			  <ActiveIcon size={22} /> PDL Contact Info - {triggerDisplay}
			</h4>
		  </div>

		  <div className="modal__body">
			{this.state.loading ? (
			  <div style={{ maxWidth: 260 }}>
				<LinearLoading />
				<p>Running PDL search…</p>
			  </div>
			) : null}

			{this.state.error && !this.state.loading ? (
			  <p style={{ color:'red' }}>{this.state.error}</p>
			) : null}

			{!this.state.loading && !this.state.error && this.state.pdl_result ? (
			  this._renderPDLSection(this.state.pdl_result)
			) : null}
		  </div>

		  <ButtonToolbar className="modal__footer offering-status">
			<hr/>
			<Button
			  className="modal_ok btn btn-primary"
			  onClick={this.toggle}
			  color="primary"
			>
			  Close
			</Button>
		  </ButtonToolbar>
		</Modal>
	  </Fragment>
	);
  }
}

PDLProfileModal.propTypes = {
  triggerDisplay: PropTypes.string.isRequired,
  user: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  url: PropTypes.string,          // optional override for API endpoint
  pdlPayload: PropTypes.object,   // optional pre-fetched PDL payload

  first_name: PropTypes.string,
  last_name: PropTypes.string,
  address_1: PropTypes.string,
  address_2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  location: PropTypes.string,
  company: PropTypes.string,
  linkedin_url: PropTypes.string
};

export default PDLProfileModal;
